import React, {forwardRef, useImperativeHandle, useState} from 'react';
import styled  from 'styled-components';
import Img1 from '../imgs/bg3.png'
import { jumpTo } from '../../../utils';
import bridge from '@/config/JSbridge'
// import { fetchScreenDetain } from "../api"
const Comfirm = forwardRef((props,ref) => {
  const [visible, setVisible] = useState(false);
  function show() {
    setVisible(true);
  }
  useImperativeHandle(ref, () => ({
    show
  }));
  function close () {
    // fetchScreenDetain()
    //   .then(()=> {
    //     props.detain();
    //     console.log();
    //   })
      props.detain();
    setVisible(false);
  }
  
  function jumpToServe() {
    jumpTo('https://m.wogoo.com/serviceCode');
  }
  function liveApp() {
    bridge.callHandler('nativeEvent', {event: 'close', params: {
      isDelete: false
    }}, () => {})
  }
  return (
    <ComfirmContainer className={visible?'':'hide'} onClick={()=>close()}>
      <div className='bg1'  >
        <div className='content' onClick={(e)=>{e.stopPropagation()}}>
          <div className='title'> 确定放弃 <br/><span className='money'>688</span>元优惠吗？</div>
          <div className='tips'>
            <p>现在下单即可享受: </p>
            <p><span className='name'>福利1：</span>会员仅需1000元<span className='money'>（过后恢 复原价1688元）</span></p>
            <p><span className='name'>福利2：</span>再赠大鳄周边1套<span className='money'>（库存 有限）</span> </p>
            <p><span className='name'>福利3：</span>
              再加赠送所购会员30天 <span className='money'>(即将失效)</span>
            </p>
          </div>
          <div className='footer'>
            <div><img onClick={()=> close()} src={require('../imgs/btn2.png')} alt=""/></div>
            <div><img onClick={()=> jumpToServe()} src={require('../imgs/btn3.png')} alt=""/></div>
            
          </div>
        </div>
        
        <div className='close' onClick={()=>liveApp()} >
          冷酷离开
        </div>
      </div>
     
    </ComfirmContainer>
  )
})

export default Comfirm;

const ComfirmContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0, 0.82);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  &.hide {
    display: none;
  }
 .title {
    font-weight: bold;
    font-size: 30px;
    color: #000000;
    line-height: 45px;
    .money {
      font-size: 44px;
      color: #ED3535;
    }
  }
  .bg1 {
    // text-align: center;
    width: 350px;
    height: 575px;
    margin: auto;
    background-image: url(${Img1});
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    .content {
      box-sizing: border-box;
      padding: 120px 23px 0;
    }
  }
  .tips {
    margin-top:10px;
    font-weight: 400;
    font-size: 18px;
    color: #000000;
    line-height: 21px;
    width: 275px;
    box-sizing: border-box;
    .name {
      font-weight: bold;
    }
    .money {
      color: #FD3032;
    }
    p {
      line-height: 1.1;
    }
  }
  .content {
     width: 100%;
  }
  
  .footer {
    width: 100%;
    box-sizing: border-box;
   >div {
    width: 100%;
    margin-bottom: 11px;
   }
    img {
      height: 40px;
      width: 100%;
    }
  }
  .close {
    position: absolute;
    margin: auto;
    text-align: center;
    left: 50%;
    transform:translatex(-50%);
    bottom: -30px;
    color: #898989;
    text-decoration: underline;
  }
`



// WEBPACK FOOTER //
// ./src/views/activity_135/components/Detention.js